import { c as _c } from "react/compiler-runtime";
import EmbedLayout from "@modules/application/components/EmbedLayout";
import { DefaultValues } from "react-hook-form";
import ApplicationStepHeader from "../ApplicationStepHeader";
import DynamicForm, { FieldValues } from "../DynamicForm";
import { FormStepComponent } from "../FormSteps/FormSteps";
const EmbeddedFormScreen = t0 => {
  const $ = _c(19);
  const {
    onNext,
    onPrevious,
    currentStepNumber,
    hasZeroStep,
    numberOfSteps,
    value,
    step
  } = t0;
  const stepNumber = hasZeroStep ? currentStepNumber : currentStepNumber + 1;
  let t1;
  if ($[0] !== step.config || $[1] !== stepNumber || $[2] !== value) {
    t1 = <div className="s:w-[360px] max-w-full"><ApplicationStepHeader config={step.config} currentStepNumber={stepNumber} value={value} /></div>;
    $[0] = step.config;
    $[1] = stepNumber;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = value as DefaultValues<T>;
  let t3;
  if ($[4] !== onNext) {
    t3 = values => onNext(values);
    $[4] = onNext;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentStepNumber || $[7] !== onPrevious) {
    t4 = currentStepNumber > 0 ? () => onPrevious() : undefined;
    $[6] = currentStepNumber;
    $[7] = onPrevious;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== step.config || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <DynamicForm id="form" defaultValues={t2} onSubmit={t3} formDefinition={step.config} onPrevious={t4} />;
    $[9] = step.config;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== currentStepNumber || $[15] !== numberOfSteps || $[16] !== t1 || $[17] !== t5) {
    t6 = <EmbedLayout><EmbedLayout.Body currentStepNumber={currentStepNumber} numberOfSteps={numberOfSteps} state={currentStepNumber}>{t1}{t5}</EmbedLayout.Body></EmbedLayout>;
    $[14] = currentStepNumber;
    $[15] = numberOfSteps;
    $[16] = t1;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default EmbeddedFormScreen;